module.exports = __webpack_public_path__ + "media/images/subject_img/MECHANICAL ENGINEERING-b9e4bdaa8083f97ad943fb0c56983029.jpg";